import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import axios from 'axios';
import logo from '../../assets/NE3_logo.svg';


function Login({ setIsAuthenticated }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        /* try {
            const response = await axios.post('http://localhost:3000/api/auth/login', {
                username,
                password,
            });
    
             if (response.data && response.data.token) {
                // Almacenar token y datos adicionales si es necesario
                sessionStorage.setItem('token', response.data.token);
                sessionStorage.setItem('user', JSON.stringify({
                    username: response.data.username,
                    // otros datos de usuario que puedas necesitar
                }));
                
                setIsAuthenticated(true);
                navigate('/');
            } else {
                setError('Credenciales incorrectas o respuesta inválida del servidor');
            }
        } catch (error) {
            let errorMessage = 'Error en el inicio de sesión';
            if (error.response) {
                if (error.response.status === 401) {
                    errorMessage = 'Usuario o contraseña incorrectos';
                } else {
                    errorMessage = error.response.data?.message || errorMessage;
                }
            }
            setError(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };*/

  try {
        const response = await axios.post('https://mapa.ne3publicidad.com.ar/api/api/auth/login', {
            username,
            password,
        });

         if (response.data && response.data.token) {
                // Almacenar token y datos adicionales si es necesario
                sessionStorage.setItem('token', response.data.token);
                sessionStorage.setItem('user', JSON.stringify({
                    username: response.data.username,
                    // otros datos de usuario que puedas necesitar
                }));
                
                setIsAuthenticated(true);
                navigate('/');
            } else {
                setError('Credenciales incorrectas o respuesta inválida del servidor');
            }
        } catch (error) {
            let errorMessage = 'Error en el inicio de sesión';
            if (error.response) {
                if (error.response.status === 401) {
                    errorMessage = 'Usuario o contraseña incorrectos';
                } else {
                    errorMessage = error.response.data?.message || errorMessage;
                }
            }
            setError(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };
    
    

    return (
        <div className="login-container" style={{ backgroundImage: `url(${logo})`}}>
            <div className="login-form">
                <h2>Iniciar sesión</h2>
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Usuario"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <TextField
                        label="Contraseña"
                        type="password"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        className="login-button"
                    >
                        Iniciar sesión
                    </Button>
                    {error && <p className="login-error">{error}</p>} 
                </form>
            </div>
        </div>
    );
}

export default Login;